import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const createPayout = createAsyncThunk("user/createPayout", async (payload) => {

  const response = await api.post("admin/payouttable/create", payload);
 
  return response.data;
});

const createPayoutSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createPayout.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPayout.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
        toast.success(action.payload.message);
      })
      .addCase(createPayout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default createPayoutSlice.reducer;
